import ApplicationAdapter from 'eflex/adapters/application';

export default class BarcodeBomSourceAdapter extends ApplicationAdapter {
  pathForType() {
    return 'bomSources';
  }
}
